// extracted by mini-css-extract-plugin
module.exports = {"driversList":"Drivers_driversList__2hJ8e","empty":"Drivers_empty__3gb2j","telegramButton":"Drivers_telegramButton__3qhas","telegramIcon":"Drivers_telegramIcon__8uDfe"};